import http from "./http";
export const baseUrl = "/v1/api/app";

const { get, post } = http;
const getRuleListApi = (params: any) => post(`${baseUrl}/rule/engine/page`, params); // 查询业务规则应用列表
const createRuleDataApi = (params: any) => post(`${baseUrl}/rule/engine/create`, params); // 业务规则创建
const checkRuleNameApi = (params: any) => post(`${baseUrl}/rule/engine/name/exist`, params); // 检查名称是否存在
const getRuleDetailApi = (params: any) => post(`${baseUrl}/rule/engine/detail`, params); // 业务规则详情
const deleteRuleDataApi = (params: any) => post(`${baseUrl}/rule/engine/delete`, params); // 业务规则删除
const reloadVersionInfoApi = (params: any) => post(`${baseUrl}/rule/engine/release/page`, params); // 重新获取版本信息
const saveRuleDataApi = (params: any) => post(`${baseUrl}/rule/engine/save`, params); // 业务规则保存
const saveAuditRuleDataApi = (params: any) => post(`${baseUrl}/rule/engine/next/save`, params); // 业务规则提交审核
const auditUpgradeRuleApi = (params: any) => post(`${baseUrl}/rule/engine/audit/upgrade`, params); // 业务规则审核升级
const auditReleaseRuleApi = (params: any) => post(`${baseUrl}/rule/engine/audit/release`, params); // 业务规则审核上架
const auditCancelUpgradeRuleApi = (params: any) => post(`${baseUrl}/rule/engine/cancel/upgrade`, params); // 业务规则撤销升级
const auditCancelReleaseRuleApi = (params: any) => post(`${baseUrl}/rule/engine/cancel/release`, params); // 业务规则撤销上架
const cancelDownRuleApi = (params: any) => post(`${baseUrl}/rule/engine/cancel/down`, params); // 撤销下架
const upgradeVersionRuleApi = (params: any) => post(`${baseUrl}/rule/engine/version/upgrade`, params); // 升级版本
const auditDownRuleApi = (params: any) => post(`${baseUrl}/rule/engine/audit/down`, params); // 审核下架
export default {
    getRuleListApi,
    createRuleDataApi,
    checkRuleNameApi,
    getRuleDetailApi,
    deleteRuleDataApi,
    saveRuleDataApi,
    reloadVersionInfoApi,
    saveAuditRuleDataApi,
    auditUpgradeRuleApi,
    auditReleaseRuleApi,
    auditCancelUpgradeRuleApi,
    auditCancelReleaseRuleApi,
    cancelDownRuleApi,
    auditDownRuleApi,
    upgradeVersionRuleApi,
};
